import { Component, OnDestroy, TemplateRef, ViewChild, inject } from '@angular/core';
import { NgbToastModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { Toast, ToastService } from '../../../Util/Toast/toast.service';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [NgbToastModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  host: { class: 'toast-container position-fixed top-0 end-0 p-3' },
})
export class ToastComponent {
  toastService = inject(ToastService);
}
